import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import GUID from "../helpers/uuidHelper";
import Table, { TableBody, TableHeader } from "@ingka/table";
import Container from "../components/layout/Container";
import { getFormattedDateTime } from "../helpers/dateTimeFormatHelper";

const regionNamesInEnglish = new Intl.DisplayNames(["en"], { type: "region" });

const Th = styled.th`
	display: ${props => (props.setDisplay ? "table-cell" : "none")};
`;

const Td = styled.td`
	display: ${props => (props.setDisplay ? "table-cell" : "none")};
`;

const OrderDetailView = ({ orderDetails, columnConfigurations }) => {
	const columns = Object.keys(columnConfigurations);
	return (
		<>
			<Container marginleft={"30px"}>
				<h3>Order information</h3>
			</Container>
			<Container justifyContent={"flex-start"} marginleft={"80px"} marginright={"30px"} maxwidth={"100%"}>
				<Table>
					<TableHeader sticky={false}>
						<tr>
							{columns.map(column => {
								const columnConfig = columnConfigurations[column];
								return (
									<Th key={GUID.Guid()} setDisplay={columnConfig.shouldDisplay}>
										{columnConfig.title}
									</Th>
								);
							})}
						</tr>
					</TableHeader>

					{orderDetails.map(detail => {
						const orderDetail = {
							...detail,
							countryCode: detail.countryCode === null || detail.countryCode === "" || detail.countryCode === undefined ? "" : regionNamesInEnglish.of(detail.countryCode),
							createDate: detail.createDate === null || detail.createDate === "" || detail.createDate === undefined ? "" : getFormattedDateTime(detail.createDate, detail.countryCode)
						};

						return (
							<TableBody key={GUID.Guid()}>
								<tr key={GUID.Guid()}>
									{columns.map(column => {
										const columnConfig = columnConfigurations[column];
										return (
											<Td key={GUID.Guid()} setDisplay={columnConfig.shouldDisplay}>
												{orderDetail[column]}
											</Td>
										);
									})}
								</tr>
							</TableBody>
						);
					})}
				</Table>
			</Container>
		</>
	);
};

OrderDetailView.propTypes = {
	orderDetails: PropTypes.array.isRequired,
	columnConfigurations: PropTypes.object.isRequired
};

export default OrderDetailView;
